import { render, staticRenderFns } from "./CreatePackages.vue?vue&type=template&id=244abeec"
import script from "./CreatePackages.vue?vue&type=script&lang=js"
export * from "./CreatePackages.vue?vue&type=script&lang=js"
import style0 from "./CreatePackages.vue?vue&type=style&index=0&id=244abeec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports